import { Component, OnInit } from '@angular/core';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'convfact-investmenttabs',
    templateUrl: './investment-tabs.component.html',
    styleUrls: ['./investment-tabs.component.css'],
    standalone: false
})
export class InvestmenttabsComponent implements OnInit {
  routes: object[];

  isSelected = false;
  isResponsive: boolean;

  constructor(
    private headerTabService: HeaderTabService
  ) {
    this.routes = [
      { label: 'Intangibles', link: '/investment/intangible', enable: true },
      { label: 'Material', link: '/investment/material', enable: true },
      { label: 'En empresas', link: '/investment/incompanies', enable: true },
      { label: 'Financieras', link: '/investment/financial', enable: true },
      { label: 'Inmobiliaria', link: '/investment/property', enable: true },
      /* { label: 'En curso', link: 'ongoing', enable: true}, */
      // { label: 'Amortizaciones', link: '/investment/amortisation', enable: true}, No se esta usando
    ];
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });

  }

  onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }
}
